/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DownloadUrlResponseDto } from '../models/download-url-response-dto';
import { mediaControllerGetDownloadUrl } from '../fn/media/media-controller-get-download-url';
import { MediaControllerGetDownloadUrl$Params } from '../fn/media/media-controller-get-download-url';
import { mediaControllerGetTestUploadUrl } from '../fn/media/media-controller-get-test-upload-url';
import { MediaControllerGetTestUploadUrl$Params } from '../fn/media/media-controller-get-test-upload-url';
import { mediaControllerGetUploadUrl } from '../fn/media/media-controller-get-upload-url';
import { MediaControllerGetUploadUrl$Params } from '../fn/media/media-controller-get-upload-url';
import { UrlResponseDto } from '../models/url-response-dto';

@Injectable({ providedIn: 'root' })
export class MediaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mediaControllerGetUploadUrl()` */
  static readonly MediaControllerGetUploadUrlPath = '/thalea-documents/upload-url';

  /**
   * Generate presigned URLs to load files with metadata.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerGetUploadUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerGetUploadUrl$Response(params?: MediaControllerGetUploadUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UrlResponseDto>>> {
    return mediaControllerGetUploadUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate presigned URLs to load files with metadata.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerGetUploadUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerGetUploadUrl(params?: MediaControllerGetUploadUrl$Params, context?: HttpContext): Observable<Array<UrlResponseDto>> {
    return this.mediaControllerGetUploadUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UrlResponseDto>>): Array<UrlResponseDto> => r.body)
    );
  }

  /** Path part for operation `mediaControllerGetTestUploadUrl()` */
  static readonly MediaControllerGetTestUploadUrlPath = '/thalea-documents/upload-url/test';

  /**
   * Generate presigned URL for test prescription uploads.
   *
   * Creates a presigned S3 URL with embedded test metadata. After file upload, pathways service will automatically create the test with prescription file attached.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerGetTestUploadUrl()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mediaControllerGetTestUploadUrl$Response(params: MediaControllerGetTestUploadUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlResponseDto>> {
    return mediaControllerGetTestUploadUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate presigned URL for test prescription uploads.
   *
   * Creates a presigned S3 URL with embedded test metadata. After file upload, pathways service will automatically create the test with prescription file attached.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerGetTestUploadUrl$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mediaControllerGetTestUploadUrl(params: MediaControllerGetTestUploadUrl$Params, context?: HttpContext): Observable<UrlResponseDto> {
    return this.mediaControllerGetTestUploadUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<UrlResponseDto>): UrlResponseDto => r.body)
    );
  }

  /** Path part for operation `mediaControllerGetDownloadUrl()` */
  static readonly MediaControllerGetDownloadUrlPath = '/thalea-documents/download-url';

  /**
   * Generate presigned download URL.
   *
   * Generate a secure, time-limited URL to download a document from S3
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerGetDownloadUrl()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mediaControllerGetDownloadUrl$Response(params: MediaControllerGetDownloadUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<DownloadUrlResponseDto>> {
    return mediaControllerGetDownloadUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * Generate presigned download URL.
   *
   * Generate a secure, time-limited URL to download a document from S3
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerGetDownloadUrl$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mediaControllerGetDownloadUrl(params: MediaControllerGetDownloadUrl$Params, context?: HttpContext): Observable<DownloadUrlResponseDto> {
    return this.mediaControllerGetDownloadUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<DownloadUrlResponseDto>): DownloadUrlResponseDto => r.body)
    );
  }

}
